export default function () {
  return [
    { id: 0, codigo: 'SIM', name: 'Sim' },
    { id: 1, codigo: 'NAO', name: 'Não' }
  ]
}



// WEBPACK FOOTER //
// ./src/constants/faixaFronteira.js